// The pre-revision customer menu used subcategory IDs 143-182. Keep the
// revised taxonomy in the API and switch only its storefront presentation.
export const CATALOG_MENU_MODE = "revised"; // Show the new level 2/3 menu.

const LEGACY_FIRST_ID = 143;
const LEGACY_LAST_ID = 182;
const LEGACY_NAMES = {
  143: "Syringes",
  144: "Disinfectant & Antiseptic",
  152: "Dental Cleaning Solution",
};
const customerTreeCache = new WeakMap();
const customerSubcategoriesCache = new WeakMap();

const isLegacySubcategory = (id) => {
  const numericId = Number(id);
  return Number.isInteger(numericId) && numericId >= LEGACY_FIRST_ID && numericId <= LEGACY_LAST_ID;
};

export const getCustomerSubcategoryLabel = (id, name) => {
  if (CATALOG_MENU_MODE !== "legacy") return name || "Sub-category";
  if (!isLegacySubcategory(id)) return "";
  return LEGACY_NAMES[Number(id)] || name || "Sub-category";
};

export const getCustomerCategoryTree = (categories) => {
  if (!Array.isArray(categories) || CATALOG_MENU_MODE !== "legacy") {
    return categories;
  }
  const cached = customerTreeCache.get(categories);
  if (cached) return cached;

  const customerTree = categories.map((category) => {
    const subcategoriesById = new Map();

    (category.sub_categories || []).forEach((subcategory) => {
      const id = Number(subcategory.id);
      if (isLegacySubcategory(id)) {
        subcategoriesById.set(id, {
          ...subcategory,
          name: LEGACY_NAMES[id] || subcategory.name,
          tags: [],
        });
      }

      // Some former level 2 entries are stored as tags after the revision.
      (subcategory.tags || []).forEach((tag) => {
        const legacyId = Number(tag.legacy_sub_category_id);
        if (isLegacySubcategory(legacyId) && !subcategoriesById.has(legacyId)) {
          subcategoriesById.set(legacyId, {
            id: legacyId,
            name: LEGACY_NAMES[legacyId] || tag.name,
            slug: tag.slug,
            featured: 0,
            image_url: null,
            tags: [],
            catalog_legacy_alias: true,
          });
        }
      });
    });

    return {
      ...category,
      sub_categories: [...subcategoriesById.values()].sort((a, b) => Number(a.id) - Number(b.id)),
    };
  });
  customerTreeCache.set(categories, customerTree);
  return customerTree;
};

export const getCustomerSubcategories = (categories) => {
  if (Array.isArray(categories)) {
    const cached = customerSubcategoriesCache.get(categories);
    if (cached) return cached;
  }
  const customerTree = getCustomerCategoryTree(categories);
  if (!Array.isArray(customerTree)) return null;

  const subcategories = customerTree.flatMap((category) =>
    (category.sub_categories || []).map((subcategory) => ({
      ...subcategory,
      category_id: category.id,
      category_name: category.name,
      catparentid: category.id,
    })),
  );
  customerSubcategoriesCache.set(categories, subcategories);
  return subcategories;
};
